import { render, staticRenderFns } from "./productDetailView.vue?vue&type=template&id=392046e8&scoped=true"
import script from "./productDetailView.vue?vue&type=script&lang=js"
export * from "./productDetailView.vue?vue&type=script&lang=js"
import style0 from "./productDetailView.vue?vue&type=style&index=0&id=392046e8&prod&scoped=true&lang=css"
import style1 from "./productDetailView.vue?vue&type=style&index=1&id=392046e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392046e8",
  null
  
)

export default component.exports